import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';

const FacebookCapiEventName = () => {
  return /*#__PURE__*/_jsx(UIFormControl, {
    "data-test-id": "fb-capi-event-name-field",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "events.creation.CRM_EVENT.name"
    }),
    children: /*#__PURE__*/_jsx(UITextInput, {
      "data-test-id": "fb-capi-event-name-input",
      disabled: true,
      value: `HubSpot - [${I18n.text('events.info.lifecycleStage')}]`
    })
  });
};

export default FacebookCapiEventName;